import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { cloneElement } from 'react';
import { baseTextParser, } from '../utils/text/baseTextParser/baseTextParser';
import { getCachedTokenSize, } from '../utils/text/tokenMeasureCache/tokenMeasureCache';
export const createTruncatedTextElement = ({ element, sizes, offset, maxWidth, }) => {
    const { props } = element;
    const { text = '' } = props;
    const ellipsisSize = getCachedTokenSize('...', props);
    const truncatePoint = sizes.findIndex((size) => size.width + offset.x + ellipsisSize.width >= maxWidth);
    return cloneElement(element, {
        text: `${text.slice(0, truncatePoint > 0 ? truncatePoint - 1 : 0)}...`,
        position: { x: offset.x, y: offset.y },
    });
};
export const _parseEllipsis = (element, { width, singleSpaceWidth, offset: initOffset }) => {
    const offset = Object.assign({}, initOffset);
    const state = { lineHighestWord: 0 };
    const { children: elements } = element.props;
    const children = baseTextParser({
        offset,
        elements,
        width,
        onTextExceedsWidth: ({ element, sizes }) => {
            const wordSize = sizes[sizes.length - 1];
            const truncatedTextElement = createTruncatedTextElement({
                element,
                sizes,
                offset,
                maxWidth: width,
            });
            const elements = [truncatedTextElement];
            state.lineHighestWord = Math.max(state.lineHighestWord, wordSize.height);
            return { elements, offset };
        },
        onTextFits: ({ element, sizes }) => {
            const wordSize = sizes[sizes.length - 1];
            const elements = [
                cloneElement(element, { position: { x: offset.x, y: offset.y } }),
            ];
            offset.x += (wordSize.width + singleSpaceWidth) | 0;
            state.lineHighestWord = Math.max(state.lineHighestWord, wordSize.height);
            return { elements, offset };
        },
    });
    return {
        children,
        height: offset.y + state.lineHighestWord,
        lines: 1,
    };
};
export function TextEllipsis({ children }) {
    return _jsx(_Fragment, { children: children });
}
